import { render, staticRenderFns } from "./quotation-and-sale-order-and-sale-contract-statistic.vue?vue&type=template&id=2ffebf08&"
import script from "./quotation-and-sale-order-and-sale-contract-statistic.vue?vue&type=script&lang=js&"
export * from "./quotation-and-sale-order-and-sale-contract-statistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports